import React, { useEffect, useState } from 'react';
import './LeaderboardModal.css';
import { LeaderboardService, LeaderboardEntry } from '../services/leaderboardService';

interface LeaderboardModalProps {
  isOpen: boolean;
  onClose: () => void;
  gameType: string;
}

const LeaderboardModal: React.FC<LeaderboardModalProps> = ({ isOpen, onClose, gameType }) => {
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchLeaderboard();
    }
  }, [isOpen, gameType]);

  const fetchLeaderboard = async () => {
    setIsLoading(true);
    try {
      const data = await LeaderboardService.getLeaderboard(gameType, 10);
      setLeaderboard(data);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      // Service sẽ tự động trả về mock data nếu có lỗi
      setLeaderboard([]);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="leaderboard-overlay" onClick={onClose}>
      <div className="leaderboard-modal" onClick={(e) => e.stopPropagation()}>
        <div className="leaderboard-header">
          <h2>🏆 BẢNG XẾP HẠNG</h2>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="leaderboard-content">
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Đang tải...</p>
            </div>
          ) : (
            <div className="leaderboard-list">
              <div className="leaderboard-header-row">
                <span>Hạng</span>
                <span>Người chơi</span>
                <span>Điểm</span>
              </div>
              {leaderboard.map((entry) => (
                <div 
                  key={entry.userId} 
                  className={`leaderboard-row ${entry.rank <= 3 ? 'top-three' : ''}`}
                >
                  <div className="rank">
                    {entry.rank === 1 && '🥇'}
                    {entry.rank === 2 && '🥈'}
                    {entry.rank === 3 && '🥉'}
                    {entry.rank > 3 && entry.rank}
                  </div>
                  <div className="username-ld">{entry.username}</div>
                  <div className="score">{entry.score.toLocaleString()}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardModal;
